import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
// import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
// import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
import DashTable from './DashTable';
import DashData from './DashData';
import NavCard from './NavCard';
import Img from '../Img';
import './dash.css';
import FooterSignedin from '../Footer.signedin';

const drawerWidth = 240;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

export default function ResponsiveDrawer(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [activeTab, setActiveTab] = React.useState<"profile" | "statistics" | "bookings">("bookings")

  const drawer = (
    <>
      <div className='bg-[#000A22] md:h-[95%] h-full flex flex-col justify-between py-6'>
        {/* <Toolbar /> */}
        <div className='w-full flex flex-col'>
          <Img
            src="/Murwiza-white.svg"
            alt="Logo"
            width={126}
            height={20}
            className='mx-4 mb-12'
          />
          <List className='w-full'>
            {['Bookings', 'Statistics', 'Profile'].map((text, index) => (
              <ListItem onClick={() => {
                setActiveTab(text.toLowerCase() as "profile" | "statistics" | "bookings")
              }} key={text} disablePadding className={`${activeTab === text.toLowerCase() ? "text-blue-500 selectedBg" : "text-white "}`}>
                <ListItemButton>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </div>
        <div className='mb-12'>
          <NavCard />
        </div>

        {/* <Divider /> */}
      </div>
    </>

  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (


    <div className='w-[95%] mx-auto'>
      <div className='h-[90%] w-[100%]'>
        <Box sx={{ display: 'flex' }}>

          <CssBaseline />
          <AppBar
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
            elevation={0}
          >
            <Toolbar className='bg-white text-black flex'>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: 'none' }}}
              >
                <MenuIcon />
              </IconButton>
              <div className='flex w-[95%] justify-between items-center mx-auto mt-6'>
                <div className='flex lg:w-[20%] w-[40%] justify-between'>
                  <div className=''>Selena Hotel Dashboard</div>
                  <div className='text-slate-400'>2022 Oct, 10</div>
                </div>
                <div className='flex items-center lg:w-[20%] justify-between'>
                  <div className='mr-6 text-slate-400'>Selena Hotel rw</div>
                  <button className='rounded-2xl py-2 px-3 bg-blue-500 text-white'>Company Profile</button>
                </div>
              </div>
            </Toolbar>


          </AppBar>
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                height: "80vh",
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, },
              }}

            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
          >
            <Toolbar />
            <DashData />
            <DashTable />
          </Box>
        </Box>
      </div>
      <div className='h-[10%] w-[100%] '>
        <div className='sm:absolute left-0 bottom-0 w-full z-[2000]'>
          <FooterSignedin />
        </div>
      </div>
    </div >

  );
}

